import * as React from 'react';
import { connect } from 'react-redux';
import { Utils, DateFormatter, domain, UiUtils, i18n, opt, isAuth, NumberFormatter } from 'arm-common';
import AppActions from '../../app/app_actions';
import * as agui from 'arm-gui/dist/controls';
import { AppConstants } from '../../constants/AppConstants';
import AccountActions from '../account/account_actions';
import LimitiAccessi from './LimitiAccessiBox.jsx'

class Manage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            // usrLinguaDefault: this.props.account.utente.codLang,
            showConfirm: false
        };
        this.componentName = "[Manage.jsx] ";
        this.changePasswordOnClick = this.changePasswordOnClick.bind(this);
        this.changeLang = this.changeLang.bind(this);
        this.saveDefaultLang = this.saveDefaultLang.bind(this);
        this.showConfirmPanel = this.showConfirmPanel.bind(this);
        this.saveI18Nlabels = this.saveI18Nlabels.bind(this);
        this.daysSamePassword = this.daysSamePassword(this);
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
    }

    componentDidMount() {
        console.log(this.componentName + "[componentDidMount]");
        let columnsAccessi = [

            { field: 'categoria', title: i18n('ARM_CORE_PRINT.CATEGORIA','Categoria'), sortable: 'true' },
            { field: 'dataLogin', title: i18n('ARM_CORE_PRINT.DATA.LOGIN','Data Login'), formatter: this.dateFormatter, sortable: 'true', },
            { field: 'applicationName', title: i18n('ARM_CORE_PRINT.APPLICAZIONE','Applicazione'), sortable: 'true' },
            { field: 'ipAddress', title: i18n('ARM_CORE_PRINT.INDIRIZZO','Indirizzo Ip'), sortable: 'true' },
            { field: 'browserName', title: i18n('ARM_CORE_PRINT.BROWSER','Browser'), sortable: 'true' },
            { field: 'resultMessage', title: i18n('ARM_CORE_PRINT.MESSAGIO','Messaggio'), sortable: 'true' },
            { field: 'resultStatus', title: i18n('ARM_CORE_PRINT.STATO','Stato'), sortable: 'true', formatter: this.columnIcon },
        ];

        $(this.refs.MyTableAccessi).bootstrapTable({
            columns: columnsAccessi,
            idField: "userId",
            sortable: true,
            search: true,
            showColumns: true,
            showExport: true,
            exportDataType: 'all',
            exportTypes: ['csv', 'excel'],
            sortOrder: "desc",
            pagination: true,
        });

        let userId = this.props.user.userId;
        console.log(this.componentName + ' id del profilo: ' + userId);

        let limitAccessi = 7
        this.props.accessList(userId, limitAccessi);;
        console.log(this.componentName + "QUESTO E' L'ID CHE PRENDO PER gli accessi: " + userId + " con limite di : ");
    }

    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');
        if (nextProps.accessi !== undefined && nextProps.accessi !== this.props.accessi.listaAccessi) {
            console.log("\t rows: " + (nextProps.accessi !== null ? nextProps.accessi.length : "NULL"));

            if (nextProps.accessi === null) {
                $(this.refs.MyTableAccessi).bootstrapTable('removeAll');
            } else {
                $(this.refs.MyTableAccessi).bootstrapTable('load', nextProps.accessi);
            }
        }
    }

    columnIcon(value, row, index) {
        console.log("[Manage.jsx]" + " columnIcon: " + index, row);
        let temp;
        if (row.resultStatus != "1") {
            temp = "<div><i class='far fa-times-circle fa-2x' data-toggle='tooltip' data-placement='top' title='WITH ERROR' data-toggle='tooltip' data-placement='top' style='color:red ' /></div>";
            return temp;
        } else if (row.resultStatus == "1") {
            temp = "<div><i class='far fa-check-circle  fa-2x' data-toggle='tooltip' data-placement='top' title='OK' data-toggle='tooltip' data-placement='top' style='color:green' /></div>";
            return temp;
        }
    }

    changePasswordOnClick() {
        console.log(this.componentName + 'changePasswordOnClick');
        this.props.history.push({ pathname: '/account/changePassword' });
    }

    dateFormatter(value, row, index) {
        return DateFormatter.dataFormatter(value);
    }

    daysSamePassword() {
        console.log(this.componentName + ' [daysSamePassord]');

        let dataOdierna = Date.now();
        console.log(this.componentName + 'la dataOdierna è: ' + dataOdierna);

        let differenzaDate = dataOdierna - this.props.user.datePasswordModified;
        console.log(this.componentName + ' la differenza tra date è: ' + differenzaDate);

        let differenzaDateInGiorni = Math.floor(differenzaDate / (1000 * 60 * 60 * 24));
        console.log(this.componentName + ' la differenza tra date in giorni è: ' + differenzaDateInGiorni);
        return differenzaDateInGiorni;
    }

    changeLang(e) {
        console.log(this.componentName + 'changeLang [' + e.target.id + '] [' + e.target.value + ']');
        let lang = e.target.value;
        //this.setState({ usrLinguaDefault: value })
        this.props.changeLocate(lang).then(
            resolve => {
                this.forceUpdate();
            }
        )
    }

    saveDefaultLang() {
        let user = this.props.account.utente;
        let userId = this.props.user.userId;
        user.codLang = this.props.locate;
        this.props.updateDefaultLanguage(user.codLang, userId);
    }

    showConfirmPanel() {
        console.log(this.componentName + "saveI18Nlabels");
        this.setState({ showConfirm: !this.state.showConfirm });
    }

    saveI18Nlabels() {
        console.log(this.componentName + "saveI18Nlabels");
        this.showConfirmPanel();
        this.props.saveI18Nlabels().then(
            resolve => {
                this.props.loadI18nLabels(AppConstants.I18N_CODES, this.props.locate)
            },
            reject => {
                console.log(this.componentName + "saveI18Nlabels KO");
            }
        );
    }

    inputChangeHandler(e, index) {
        if (e.target.value === null || e.target.value === undefined || e.target.value === '') {
            let value = 7;
            let userId = this.props.user.userId;
            console.log(this.componentName + " " + value);
            this.props.accessList(userId, value);
        } else {
            let value = e.target.value;
            let id = e.target.id;
            let userId = this.props.user.userId;
            console.log(this.componentName + id + " " + value);
            this.props.accessList(userId, value);
        }
    }

    render() {
        console.log(this.componentName + "render");
        let elencoRuoliString = '';
        let arrayRuoli = this.props.account.utente.roles;
        if (arrayRuoli !== undefined && arrayRuoli !== null) {
            for (let i = 0; i < arrayRuoli.length; i++) {
                let currRuolo = arrayRuoli[i];
                if (elencoRuoliString !== '') {
                    elencoRuoliString = elencoRuoliString + ', ';
                }
                elencoRuoliString = elencoRuoliString + currRuolo;
            }
        }

        // let authorizations = this.props.authorizations;
        let authorizations = this.props.account.utente.authorizations;
        return (
            <div>

                <p className="lead">{i18n("ARM_CORE_PRINT.MANAGE.BENVENUTO", "Benvenuto")} {this.props.account.utente.userId}, {i18n("ARM_CORE_PRINT.MANAGE.ULTIMOACCESSO", "il tuo ultimo accesso risale al")}: {DateFormatter.dataFormatter(this.props.account.utente.dateLastLogin)}</p>
                <br />

                <div className="row pl-3 pr-3">

                    <div className="col-lg-6" style={{ display: "grid" }}>
                        <div className="card" style={{ minHeight: "230px" }}>

                            <div className="card-header">
                                {i18n('BAD.MENUTOP.PROFILO', 'Profilo')}
                                <i className="fas fa-user fa-2x float-right"></i>
                            </div>

                            <div className="card-body mt-3">
                                <dl className="row">
                                    <dt className="col-sm-2 col-6">{i18n('BAD.MANAGE.NOME', 'Nome')}</dt>
                                    <dd className="col-sm-3 col-6 ">{this.props.user.name}</dd>
                                    <dt className="col-sm-2 col-6 text-nowrap">{i18n('BAD.MANAGE.COGNOME', 'Cognome')}</dt>
                                    <dd className="col-sm-3 col-6 ">{this.props.user.lastName}</dd>
                                </dl>

                                <dl className="row">
                                    <dt className="col-sm-2 col-6 text-nowrap">{i18n('BAD.MANAGE.LOGIN', 'Login')}</dt>
                                    <dd className="col-sm-3 col-6 ">{this.props.user.userId}</dd>
                                    <dt className="col-sm-2 col-6 text-nowrap">{i18n('BAD.MANAGE.EMAIL', 'Email')}</dt>
                                    <dd className="col-sm-5 col-6 ">{this.props.user.email}</dd>
                                </dl>

                                <dl className="row">
                                    <dt className="col-sm-2 col-6 text-nowrap">{i18n('ARM_CORE_PRINT.MANAGE.RUOLI', 'Ruoli')}</dt>
                                    <dd className="col-sm-3 col-6 ">{elencoRuoliString}</dd>
                                </dl>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="card h-100" style={{ minHeight: "230px" }}>

                            <div className="card-header ">
                                {i18n('ARM_CORE_PRINT.GESTIONE', 'Gestione Password e Lingua')}
                                <i className="fas fa-key fa-2x float-right" />
                            </div>

                            <div className="card-body m-3">

                                <dl className="row">
                                    <dt className="col-sm-2 col-6" >{i18n("ARM_CORE_PRINT.DATA_ULTIMA", "Data ultima modifica")}</dt>
                                    <dd className="col-sm-3 col-6 " >{DateFormatter.dataFormatter(this.props.user.datePasswordModified)}</dd>

                                    <dt className="col-sm-3 col-6 " >{i18n("ARM_CORE_PRINT.MANAGE.GIORNI.ULTIMA.MODIFICA", "Giorni dall'ultima modifica")}</dt>
                                    <dd className="col-sm-3 col-6" >{this.daysSamePassword}<span> </span>


                                        {this.daysSamePassword < 30 ? <button className="btn btn-success" type="button" disabled style={{ width: "100px" }} data-toggle="tooltip" data-placement="top" title={i18n("ARM_CORE_PRINT.MANAGE.STAO.PASSWORD.OK", "Stato password OK")}></button>
                                            :

                                            this.daysSamePassword >= 30 && this.daysSamePassword <= 90 ? <button className="btn btn-warning" type="button" disabled style={{ width: "100px" }} data-toggle="tooltip" data-placement="top" title={i18n("ARM_CORE_PRINT.MANAGE.STAO.PASSWORD.DA.CAMBIARE.BREVE", "Stato password da cambiare a breve")}> </button>
                                                :

                                                this.daysSamePassword > 90 ? <button className="btn btn-danger" type="button" disabled style={{ width: "100px" }} data-toggle="tooltip" data-placement="top" title={i18n("ARM_CORE_PRINT.MANAGE.STAO.PASSWORD.DA.CAMBIARE", "Stato password da cambiare")}> </button> : null}
                                    </dd>
                                </dl>

                                <agui.aButton type="button" className="btn btn-primary float-right" onClick={this.changePasswordOnClick}  ><i className="fa fa-key fa-fw" />{i18n('BAD.MANAGE.MODIFICAPASSWORD', 'Modifica Password')}</agui.aButton>

                                <div className="mt-5" >
                                    <agui.CoolSelect
                                        id="lingua"
                                        disabled={false}
                                        required={false}
                                        //classNameComponent="row"
                                        //classNameLabel="col-4"
                                        onChange={(value) => this.changeLang({
                                            target: {
                                                value: value,
                                                id: "lingua"
                                            }
                                        })}
                                        value={this.props.locate}
                                        label={i18n("ARM_CORE_PRINT.MANAGE.LINGUA", "Lingua")}
                                        items={domain("LANG")}
                                        valueKey="valCampo"
                                        labelKey="desDom"
                                    />

                                    <button type="button" className="btn btn-primary float-right" disabled={false} onClick={this.saveDefaultLang}>
                                        <i className="fa fa-key fa-fw" />{i18n("ARM_CORE_PRINT.MANAGE.SALVA", "Salva")}
                                    </button>
                                </div>

                            </div>

                        </div>
                    </div>

                    <div className="col-md-12">
                        <div className="card mt-3">

                            <div className="card-header">
                                {i18n("ARM_CORE_PRINT.MANAGE.ULTIMI.ACCESSI", "Ultimi Accessi")}
                                <i className="fas fa-sign-in-alt fa-2x float-right"></i>
                            </div>

                            <div className="card-body">
                                <LimitiAccessi id="MyTableAccessi"
                                     label= {i18n('ARM.CORE.PRINT.ACCOUNT.ACCESSI.DI', 'Accessi di')}
                                    inputChangeHandler={(e) => this.inputChangeHandler(e)} />

                                <table ref="MyTableAccessi" className={AppConstants.CLASS_TABLE} />
                            </div>

                        </div>
                    </div>

                    {
                        opt("I18N", "EVIDENZIA_LABEL_MANCANTI", "false") == "TRUE" &&
                        // <agui.aButton type="button" className="btn btn-primary mt-3" onClick={this.showConfirmPanel}>
                        //     <i className="fa fa-tags fa-fw" />{i18n("ARM_CORE_PRINT.MANAGE.SALVA_i18N_LABELS", "Salva I18N labels")}
                        // </agui.aButton>
                        <agui.aButton className="btn btn-primary mt-3" onClick={this.saveI18Nlabels} askConfirm={i18n('ARM_CORE_PRINT.DOMANDA.CONFERMI_SALVATAGGIO', 'Confermi di voler salvare?')}>
                            <i className="fa fa-tags fa-fw" />{i18n("ARM_CORE_PRINT.MANAGE.SALVA_i18N_LABELS", "Salva I18N labels")}
                        </agui.aButton>
                    }

                </div>
            </div>

        );
    }
};

function mapStateToProps(state) {
    return {
        account: state.account,
        i18n: state.app.i18nlabels,
        locate: state.app.locate,
        authorizations: state.app.authorizations,
        user: state.account.utente,
        accessi: state.account.listaAccessi,
    };
};

function mapDispatchToProps(dispatch) {
    return {
        changeLocate(lingua) {
            return dispatch(AppActions.changeLocate(lingua));
        },
        updateDefaultLanguage(codLang, userId) {
            return dispatch(AccountActions.saveDefaultLangById(codLang, userId));
        },
        saveI18Nlabels: function () {
            return dispatch(AppActions.saveI18Nlabels());
        },

        loadI18nLabels: function () {
            return dispatch(AppActions.loadI18nLabels(filter, lang));
        },
        accessList(userId, limitAccessi) {
            return dispatch(AccountActions.getListaAccessiUtente(userId, limitAccessi));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Manage);
